"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'See more': 'See more',
            'See less': 'See less',
            'Toggle Menu': 'Toggle Menu',
            'See all': 'See all'
        }
    },
    'es': {
        'translation': {
            'Toggle Menu': 'Menú de alternar',
            'See more': 'Ver más',
            'See less': 'Ver menos',
            'See all': 'See all'
        }
    },
    'cs': {
        'translation': {
            'See more': 'více',
            'See less': 'méně',
            'Toggle Menu': 'Menu',
            'See all': 'See all'
        }
    },
    'zh': {
        'translation': {
            'See more': '查看更多',
            'See less': '查看更少',
            'Toggle Menu': '切换菜单',
            'See all': 'See all'
        }
    },
    'he': {
        'translation': {
            'See more': 'הצג עוד',
            'See less': 'הצג פחות',
            'Toggle Menu': 'הצג / הסתר תפריט',
            'See all': 'See all'
        }
    }
};
